import isEmpty from 'lodash/isEmpty';

export function urlToQueryKey(url) {
  return url.split('/');
}

export function buildQueryDescriptor(url, client, params) {
  const { namespace = 'root', queryParams = {}, ...restParams } = params || {};

  const queryFn = ({ signal }) => client.request({ url, payload: queryParams, options: { signal } });

  const queryKey = isEmpty(queryParams)
    ? [namespace, ...urlToQueryKey(url)]
    : [namespace, ...urlToQueryKey(url), queryParams];

  return { queryKey, queryFn, restParams };
}
